import FlashCardIcon from './study-flashcard.svg';
import QuizitIcon from './study-quizit.svg';
import TutorMeIcon from './study-tutorme.svg';

export { FlashCardIcon, QuizitIcon, TutorMeIcon };
